import { createApiRef } from '@backstage/frontend-plugin-api';
import { DefaultApiResponse } from '@internal/backstage-plugin-devops-react';

export type AccountRegionStatistic = {
  region: string;
  resourcesCount: number;
  hasRegionError: boolean;
};

export type AccountCloudResourcesStatistics = {
  accountId: string;
  regions: AccountRegionStatistic[];
};

export const cloudResourcesStatisticsApiRef =
  createApiRef<CloudResourcesStatisticsApi>().with({
    id: 'cloud-resources-statistics-api',
    pluginId: 'catalog-devops',
  });

export interface CloudResourcesStatisticsApi {
  getAccountCloudResourcesStatistics(
    accountId: string,
  ): Promise<DefaultApiResponse>;
}
